module.exports = __webpack_public_path__ + "img/8.296115c0.jpg";